module.exports = __webpack_public_path__ + "static/media/Studio-Seilern-Architects.f608121f.png";